import React from "react";
import LegalLayout from "../../components/legal/LegalLayout";
import LegalTableOfContents from "../../components/legal/LegalTableOfContents";
import {
  privacyPolicySections,
  LEGAL_LAST_UPDATED,
} from "../../data/legalContent";
import LegalSectionContent from "./LegalSectionContent";

export default function PrivacyPolicyPage() {
  return (
    <LegalLayout title="Privacy Policy" lastUpdated={LEGAL_LAST_UPDATED}>
      <LegalTableOfContents sections={privacyPolicySections} />
      {privacyPolicySections.map((section) => (
        <LegalSectionContent key={section.id} section={section} />
      ))}
    </LegalLayout>
  );
}
